import { useState } from "react";
import Blog1 from "../components/Blog/Blog1";
import Blog2 from "../components/Blog/Blog2";
import Joinvillage from "../components/landingpage/Joinvillage";
import { ALL_TOPICS } from "../components/Blog/blogTopics";

const Blog = () => {
  const [category, setCategory] = useState(ALL_TOPICS);

  return (
    <div className="w-full flex flex-col items-stretch">
      <Blog1 category={category} onCategoryChange={setCategory} />
      <Blog2 category={category} />
      <Joinvillage />
    </div>
  );
};

export default Blog;
